



























































import { defineComponent, PropType, ComputedRef, computed, ref, onMounted, watch } from '@vue/composition-api';

// types
import { PendingMessage, Message } from '@/views/Admin/Channels/channelTypes';

import { Endpoints } from '@/ts/store/Constants';
import { Actions, Mutations } from '@/ts/store/modules/Channels/constants';

import axios from 'axios';
import ErrorResponse from '@/ts/ErrorResponse';

// components
import BaseAvatar from '@/components/NEW-STRUCTURE/desktop/Admin/components/BaseAvatar.vue';
import MessageAttachment from '@/views/Admin/Channels/components/MessageAttachment.vue';

// mixins
import DateMethods from '@/mixins/DateMethods.vue';

export default defineComponent({
    components: { BaseAvatar, MessageAttachment },
    props: {
        channelId: String,
        message: {
            type: Object as PropType<PendingMessage | Message>,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        groupIndex: {
            type: Number,
        },
        messageIndex: {
            type: Number,
        },
        reportedMessageStyle: Boolean,
    }, 
    mixins: [
        DateMethods,
    ],
    setup(props, { emit, root }) {
        
        const store = root.$store;

        const isPendingMessage = computed(() => props.message instanceof PendingMessage);
        const startingLetter = computed(() => {
            return props.message.author.name[0];
        });

        const hover = ref(false);

        const activeActionsMessageId = ref(0);

        const onLocalBan = () => {
            if (props.message) {
                const userId =  props.message.author.id;
                if (props.message && userId && props.channelId) {
                    axios.post(Endpoints.Admin.Channels.CHANNEL_BLOCK_USER(props.channelId, userId))
                        .then(() => {
                            store.dispatch(Actions.FETCH_BANNED_USERS, props.channelId);
                            //axios.delete(Endpoints.Admin.Channels.DELETE_USER_MESSAGES(props.channelId, userId));
                            //store.commit(Mutations.SET_FETCH_MESSAGES, true);
                        })
                        .catch((error) => {
                            if (error.response) {
                                const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                            } else {
                                console.log(error);
                            }
                        });
                }
            }
        };

        // TODO v2
        const onGlobalBan = () => {
            if (props.message instanceof Message) {
                console.log('onGlobalBan')
            }
        };

        // TODO
        const deleteMessage = () => {
            if (props.message) {
                //@ts-ignore
                axios.delete(Endpoints.Admin.Channels.DELETE_MESSAGE(props.channelId, props.message.id))
                    .then(() => {
                        store.commit(Mutations.SET_FETCH_MESSAGES, true);
                    })
                    .catch((error) => {
                        if (error.response) {
                            const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                        } else {
                            console.log(error);
                        }
                    });
            }
        };

        const handleMouseLeave = () => {
            hover.value = false;
            activeActionsMessageId.value = 0;
        };

        function showMessageActions(id: number) {
            let messageId = id;
            if (activeActionsMessageId.value !== 0) {
                messageId = 0;
            }
            activeActionsMessageId.value = messageId;
        }

        const isUser: ComputedRef<boolean> = computed(() => {
            return props.userId === props.message.author.id;
        });

        return {
           activeActionsMessageId,
           isPendingMessage,
           startingLetter,
           isUser,
           hover,
           showMessageActions,
           onLocalBan,
           onGlobalBan,
           deleteMessage,
           onMounted,
           handleMouseLeave,
        };
    },
});
